import {
  MISMEDICOS_SUCCESS,
  MISMEDICOS_LOADING,
  MISMEDICOS_ERROR,
  MISMEDICOS_RESET,
  MISMEDICOS_ALTAENCUESTA,
  MISMEDICOS_RESETENCUESTA,
  MISMEDICOS_FLGRECARGAR,
  MISMEDICOS_FLGRECARGAR_RESET,
  RESET_PORTAL_CONTEXT,
} from "../ActionTypes";
import misMedicosInitialState from "../initialStates/misMedicosInitialState";

const misMedicos = (state, { payload, type }) => {
  switch (type) {
    case MISMEDICOS_LOADING:
      return {
        ...state,
        misMedicos: {
          ...state.misMedicos,
          error: false,
          loading: true,
        },
      };
    case MISMEDICOS_SUCCESS:
      return {
        ...state,
        misMedicos: {
          ...state.misMedicos,
          loading: false,
          error: false,
          data: payload,
        },
      };
    case MISMEDICOS_ERROR:
      return {
        ...state,
        misMedicos: {
          ...state.misMedicos,
          error: payload,
          loading: false,
        },
      };
    case MISMEDICOS_ALTAENCUESTA:
      return {
        ...state,
        misMedicos: {
          ...state.misMedicos,
          loading: false,
          error: false,
          altaEncuesta: payload,
        },
      };
    case MISMEDICOS_FLGRECARGAR:
      return {
        ...state,
        misMedicos: {
          ...state.misMedicos,
          loading: false,
          error: false,
          flgRecarga: payload,
        },
      };
    case MISMEDICOS_FLGRECARGAR_RESET:
      return {
        ...state,
        misMedicos: {
          ...state.misMedicos,
          loading: false,
          error: false,
          flgRecarga: null,
        },
      };
    case MISMEDICOS_RESETENCUESTA:
      return {
        ...state,
        misMedicos: {
          ...state.misMedicos,
          altaEncuesta: null,
        },
      };
    case MISMEDICOS_RESET:
      return misMedicosInitialState;
    case RESET_PORTAL_CONTEXT:
      return misMedicosInitialState;

    default:
      return state;
  }
};

export default misMedicos;
